import React, { Component } from "react";
import PageHelmet from "../component/common/Helmet";
import ScrollToTop from 'react-scroll-up';
import { FiChevronUp } from "react-icons/fi";
import Header from "../component/header/Header";
import { Link } from 'react-router-dom';
import { withTranslation } from 'react-i18next';

const ACTIVITIES = [
  { img: '/assets/images/portfolio/21.webp', titleKey: 'pastActivities.item1Title', descKey: 'pastActivities.item1Desc' },
  { img: '/assets/images/portfolio/2.webp', titleKey: 'pastActivities.item2Title', descKey: 'pastActivities.item2Desc' },
  { img: '/assets/images/portfolio/51.webp', titleKey: 'pastActivities.item3Title', descKey: 'pastActivities.item3Desc' },
  { img: '/assets/images/portfolio/52.webp', titleKey: 'pastActivities.item4Title', descKey: 'pastActivities.item4Desc' },
  { img: '/assets/images/portfolio/4.webp', titleKey: 'pastActivities.item5Title', descKey: 'pastActivities.item5Desc' },
  { img: '/assets/images/portfolio/18.webp', titleKey: 'pastActivities.item6Title', descKey: 'pastActivities.item6Desc' },
  { img: '/assets/images/portfolio/portfolio-g.webp', titleKey: 'pastActivities.item7Title', descKey: 'pastActivities.item7Desc' },
  // กลางปี 2568 – มีนาคม 2569 (รูปจากข่าวจริง โหลดด้วย node scripts/download-news-images.js)
  { img: '/assets/images/news/news-4-activity-a.jpg', titleKey: 'pastActivities.item8Title', descKey: 'pastActivities.item8Desc' },
  { img: '/assets/images/news/news-4-governor-kindergarten.jpg', titleKey: 'pastActivities.item9Title', descKey: 'pastActivities.item9Desc' },
  { img: '/assets/images/contact/reward-2.webp', titleKey: 'pastActivities.item10Title', descKey: 'pastActivities.item10Desc' },
  { img: '/assets/images/news/news-1-tatstar-cover.jpg', titleKey: 'pastActivities.item11Title', descKey: 'pastActivities.item11Desc' },
];

class PastActivities extends Component {
  render() {
    const { t } = this.props;
    return (
      <React.Fragment>
        <PageHelmet
          pageTitle={t('pastActivities.pageTitle')}
          description={t('pastActivities.metaDescription')}
          keywords={t('pastActivities.metaKeywords')}
          siteName={t('common.siteName')}
        />
        <Header headertransparent="header--transparent" colorblack="color--black" logoname="logo.webp" />

        <main className="past-activities-modern bg_color--1" role="main">
          <section className="past-modern-hero" aria-label={t('pastActivities.heroTitle')}>
            <div className="container">
              <div className="past-modern-hero-inner">
                <div className="past-modern-kicker">Past Activities</div>
                <h1 className="past-modern-title">{t('pastActivities.heroTitle')}</h1>
                <p className="past-modern-subtitle">{t('pastActivities.heroSubtitle')}</p>
                <p className="past-modern-desc">{t('pastActivities.heroDesc')}</p>
                <div className="past-modern-actions">
                  <Link to="/education" className="btn-default">
                    {t('pastActivities.ctaProgram')}
                  </Link>
                  <Link to="/contract" className="btn-default btn-border">
                    {t('pastActivities.ctaContact')}
                  </Link>
                </div>
              </div>
            </div>
          </section>

          <section className="past-modern-section" aria-label={t('pastActivities.sectionTitle')}>
            <div className="container">
              <div className="past-modern-head">
                <h2 className="past-modern-section-title">{t('pastActivities.sectionTitle')}</h2>
              </div>
              <div className="row row--20 past-modern-grid">
                {ACTIVITIES.map((item, index) => (
                  <div key={index} className="col-lg-4 col-md-6 col-12 past-modern-col">
                    <article className="past-modern-card">
                      <div className="past-modern-thumb">
                        <img src={item.img} alt={t(item.titleKey)} loading="lazy" />
                      </div>
                      <div className="past-modern-content">
                        <h3 className="past-modern-card-title">{t(item.titleKey)}</h3>
                        <p className="past-modern-card-desc" style={{ whiteSpace: 'pre-line' }}>
                          {t(item.descKey)}
                        </p>
                      </div>
                    </article>
                  </div>
                ))}
              </div>
            </div>
          </section>

          <section className="past-modern-section" aria-label={t('pastActivities.ctaTitle')}>
            <div className="container">
              <div className="past-modern-cta">
                <h2 className="past-modern-section-title">{t('pastActivities.ctaTitle')}</h2>
                <p className="past-modern-desc">{t('pastActivities.ctaDesc')}</p>
                <div className="past-modern-actions">
                  <Link to="/education" className="btn-default">
                    {t('pastActivities.ctaProgram')}
                  </Link>
                  <Link to="/contract" className="btn-default btn-border">
                    {t('pastActivities.ctaContact')}
                  </Link>
                </div>
              </div>
            </div>
          </section>
        </main>

        <div className="backto-top">
          <ScrollToTop showUnder={160}>
            <FiChevronUp />
          </ScrollToTop>
        </div>
      </React.Fragment>
    );
  }
}
export default withTranslation()(PastActivities);
